<template>
  <validation-provider
    v-slot="{ errors }"
    :name="$attrs.name"
    :rules="iRules"
    :vid="vid"
  >
    <v-label
      v-if="fixedLabel"
      :dark="fixedLabelDark"
    >
      {{ displayLabel }}
    </v-label>
    <v-textarea
      v-model="iValue"
      v-bind="$attrs"
      :background-color="backgroundColor"
      :counter="counter"
      :dense="dense"
      :error-messages="errors"
      :error="validation && !!errors.length"
      :label="(!fixedLabel && displayLabel) || ''"
      :hide-details="(!errors.length || !validation) && !counter"
      :maxlength="limit"
      :outlined="outlined"
      :rows="rows"
    />
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { useValidation } from '@/compositions/validation'

export default {
  name: 'FieldTextarea',
  components: {
    ValidationProvider
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'white'
    },
    counter: {
      type: [Boolean, Number, String],
      default: undefined
    },
    dense: {
      type: Boolean,
      default: true
    },
    fixedLabel: Boolean,
    fixedLabelDark: Boolean,
    label: {
      type: String,
      default: null
    },
    limit: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: true
    },
    rows: {
      type: Number,
      default: 5
    },
    rules: {
      type: [String, Object],
      default: () => ({})
    },
    validation: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const { iRules, displayLabel } = useValidation(props)

    return { iRules, displayLabel }
  },
  computed: {
    iValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
